import React from "react";
import styles from "./Boton.module.css";
import * as Imagenes from "../Iconos.js";

const BotonBuscarChico = (props) => {
  const estilo = props.estilo;
  const onClick = props.onClick;

  return (
    <button className={`${styles.botonTransparente} ${estilo}`} onClick={onClick}>
      <img
        src={Imagenes.buscar}
        width="15px"
        height="15px"
        alt="Buscar"
      />
    </button>
  );
};

export default BotonBuscarChico;
